import { GetHighlightProps, GetValueWithTwoDecimals } from './types';

export const getHighlightedValue = ({ value, calculationValue }: GetHighlightProps): boolean => {
  return value === calculationValue;
};

export const getValueWithTwoDecimals = ({ value }: GetValueWithTwoDecimals) => {
  return Math.round(Number(value) * 100) / 100;
};
